import * as React from "react";
import type { SVGProps } from "react";
const SvgFileAttach02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeWidth={2}
      d="M10.8 21.6H6.6a2.4 2.4 0 0 1-2.4-2.4V4.8a2.4 2.4 0 0 1 2.4-2.4h10.8a2.4 2.4 0 0 1 2.4 2.4v5.4m-6 5.354V18.5c0 1.454 1.552 2.789 3.007 2.789s2.993-1.335 2.993-2.79V14.78c0-.77-.443-1.552-1.428-1.552-1.053 0-1.565.782-1.565 1.552v3.565"
    />
  </svg>
);
export default SvgFileAttach02;
